import {IEvaluatorOptions} from "./i-evaluator-options";
import {TS} from "../../type/ts";

/**
 * Evaluates, or attempts to evaluate, a TypeAliasDeclaration
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function evaluateInterfaceDeclaration(_options: IEvaluatorOptions<TS.InterfaceDeclaration>): void {
	return;
}
